module.exports = __webpack_public_path__ + "static/media/20210410_191048_102_IMG_0310.f486b234.jpg";